import { createReducer, on } from '@ngrx/store'
import * as dashboardActions from './dashboard.actions'
import { ChannelProduct, ChannelProductTransaction, MTBTransactions, OutstandingBalance, PaymentChannel, ProductEarning } from './dashboard.interfaces'

export interface DashboardState {
    outstandingBalance: OutstandingBalance,
    outstandingBalanceError: boolean
    loadingOutstandingBalance: boolean

    transactionHistory,
    transactionHistoryLoading: boolean
    transactionHistoryError: boolean

    pendingTransactions,
    pendingTransactionsLoading: boolean
    pendingTransactionsError: boolean

    paymentChannels: PaymentChannel[],
    paymentChannelsLoading: boolean
    paymentChannelsError: boolean

    channelProducts: ChannelProduct[],
    channelProductsLoading: boolean
    channelProductsError: boolean

    productsEarnings: ProductEarning[],
    productsEarningsLoading: boolean
    productsEarningsError: boolean

    dailyTransactions: ChannelProductTransaction[],
    dailyTransactionsLoading: boolean
    dailyTransactionsError: boolean

    mtbTransactions: MTBTransactions[],
    mtbTransactionsLoading: boolean
    mtbTransactionsError: boolean

}

export const initialState: DashboardState = {
    outstandingBalance: null,
    outstandingBalanceError: null,
    loadingOutstandingBalance: null,

    transactionHistory: null,
    transactionHistoryError: null,
    transactionHistoryLoading: null,

    pendingTransactions: null,
    pendingTransactionsError: null,
    pendingTransactionsLoading: null,

    paymentChannels: null,
    paymentChannelsLoading: null,
    paymentChannelsError: null,

    channelProducts: null,
    channelProductsLoading: null,
    channelProductsError: null,

    productsEarnings: null,
    productsEarningsLoading: null,
    productsEarningsError: null,

    dailyTransactions: null,
    dailyTransactionsLoading: null,
    dailyTransactionsError: null,

    mtbTransactions: null,
    mtbTransactionsLoading: null,
    mtbTransactionsError: null,
}

export const DashboardReducer = createReducer(
    initialState,

    on(dashboardActions.fetchOutstandingBalance, (state) => ({
        ...state, outstandingBalance: null, outstandingBalanceError: null, loadingOutstandingBalance: true
    })),

    on(dashboardActions.fetchOutstandingBalanceSuccess, (state, {outstandingBalance}) => ({
        ...state, outstandingBalance: outstandingBalance, outstandingBalanceError: false, loadingOutstandingBalance: false
    })),

    on(dashboardActions.fetchOutstandingBalanceFailed, (state) => ({
        ...state, outstandingBalance: null, outstandingBalanceError: true, loadingOutstandingBalance: false
    })),



    on(dashboardActions.fetchTransactionHistory, (state) => ({
        ...state, transactionHistory: null, transactionHistoryError: null, transactionHistoryLoading: true
    })),

    on(dashboardActions.fetchTransactionHistorySuccess, (state, {transactionHistory}) => ({
        ...state, transactionHistory: transactionHistory, transactionHistoryError: false, transactionHistoryLoading: false
    })),

    on(dashboardActions.fetchTransactionHistoryFailed, (state) => ({
        ...state, transactionHistory: null, transactionHistoryError: true, transactionHistoryLoading: false
    })),


    on(dashboardActions.fetchPendingTransactions, (state) => ({
        ...state, pendingTransactions: null, pendingTransactionsError: null, pendingTransactionsLoading: true
    })),

    on(dashboardActions.fetchPendingTransactionsSuccess, (state, {pendingTransactions}) => ({
        ...state, pendingTransactions: pendingTransactions, pendingTransactionsError: false, pendingTransactionsLoading: false
    })),

    on(dashboardActions.fetchPendingTransactionsFailed, (state) => ({
        ...state, pendingTransactions: null, pendingTransactionsError: true, pendingTransactionsLoading: false
    })),


    on(dashboardActions.fetchPaymentChannels, (state) => ({
        ...state, paymentChannels: null, paymentChannelsError: null, paymentChannelsLoading: true
    })),

    on(dashboardActions.fetchPaymentChannelsSuccess, (state, {paymentChannels}) => ({
        ...state, paymentChannels: paymentChannels, paymentChannelsError: false, paymentChannelsLoading: false
    })),

    on(dashboardActions.fetchPaymentChannelsFailed, (state) => ({
        ...state, paymentChannels: null, paymentChannelsError: true, paymentChannelsLoading: false
    })),


    on(dashboardActions.fetchChannelProducts, (state) => ({
        ...state, channelProducts: null, channelProductsError: null, channelProductsLoading: true
    })),

    on(dashboardActions.fetchChannelProductsSuccess, (state, {channelProducts}) => ({
        ...state, channelProducts: channelProducts, channelProductsError: false, channelProductsLoading: false
    })),

    on(dashboardActions.fetchChannelProductsFailed, (state) => ({
        ...state, channelProducts: null, channelProductsError: true, channelProductsLoading: false
    })),



    on(dashboardActions.fetchProductEarning, (state) => ({
        ...state, productsEarnings: null, productsEarningsError: null, productsEarningsLoading: true
    })),

    on(dashboardActions.fetchProductEarningSuccess, (state, {productEarning}) => ({
        ...state, productsEarnings: productEarning, productsEarningsError: false, productsEarningsLoading: false
    })),

    on(dashboardActions.fetchProductEarningFailed, (state) => ({
        ...state, productsEarnings: null, productsEarningsError: true, productsEarningsLoading: false
    })),



    on(dashboardActions.fetchTransactionsPerDay, (state) => ({
        ...state, dailyTransactions: null, dailyTransactionsError: null, dailyTransactionsLoading: true
    })),

    on(dashboardActions.fetchTransactionsPerDaySuccess, (state, {transactions}) => ({
        ...state, dailyTransactions: transactions, dailyTransactionsError: false, dailyTransactionsLoading: false
    })),

    on(dashboardActions.fetchTransactionsPerDayFailed, (state) => ({
        ...state, dailyTransactions: null, dailyTransactionsError: true, dailyTransactionsLoading: false
    })),


    on(dashboardActions.fetchMTBtransactions, (state) => ({
        ...state, mtbTransactions: null, mtbTransactionsError: null, mtbTransactionsLoading: true
    })),

    on(dashboardActions.fetchMTBtransactionsSuccess, (state, {transactions}) => ({
        ...state, mtbTransactions: transactions, mtbTransactionsError: false, mtbTransactionsLoading: false
    })),

    on(dashboardActions.fetchMTBtransactionsFailed, (state) => ({
        ...state, mtbTransactions: null, mtbTransactionsError: true, mtbTransactionsLoading: false
    })),
)